import {
  providerIgnoredRequestsListColumnVisibilityOptions,
  defaultProviderIgnoredRequestsListFilter,
  defaultProviderIgnoredRequestsListColumnVisibility,
} from '@utils/tables/providerIgnoredRequests/providerIgnoredRequestsListFilter';
// System
import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  limit: 25,
  page: 1,
  total: 0,
  selectedFilters: defaultProviderIgnoredRequestsListFilter,
  columnVisibility: defaultProviderIgnoredRequestsListColumnVisibility,
  columnVisibilityOptions: providerIgnoredRequestsListColumnVisibilityOptions,
  providerIgnoredRequestsTableFilters: {},
};

const providerIgnoredRequestsTableSlice = createSlice({
  name: 'providerIgnoredRequestsTable',
  initialState,
  reducers: {
    setColumnVisibility: (state, { payload }) => {
      state.columnVisibility = payload;
    },
    setLimit: (state, { payload }) => {
      state.limit = payload;
    },
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    setTotal: (state, { payload }) => {
      state.total = payload;
    },
    setProviderIgnoredRequestsTableFilters: (state, { payload }) => {
      const { codeName, value } = payload;
      const { providerIgnoredRequestsTableFilters } = state;

      const convertedValue = typeof value !== 'object' || value === null ? value : value[0];
      const newProviderTransactionTableFilters = {
        ...providerIgnoredRequestsTableFilters,
        [codeName]:
          convertedValue === 'true' ? true : convertedValue === 'false' ? false : convertedValue,
      };
      state.providerIgnoredRequestsTableFilters = newProviderTransactionTableFilters;
    },
    setClearProviderIgnoredRequestsTableFilters: (state) => {
      state.providerIgnoredRequestsTableFilters = {};
    },
  },
  extraReducers: {},
});

export const { reducer: providerIgnoredRequestsTableReducer } = providerIgnoredRequestsTableSlice;
export const {
  setColumnVisibility,
  setLimit,
  setPage,
  setTotal,
  setProviderIgnoredRequestsTableFilters,
  setClearProviderIgnoredRequestsTableFilters,
} = providerIgnoredRequestsTableSlice.actions;
